/**
 * 编辑视图模块路由
 */
export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "poster/template",
            component: resolve => require(["@/modules/poster/pages/template.vue"], resolve)
          },
          {
            path: "poster/list",
            component: resolve => require(["@/modules/poster/pages/list.vue"], resolve)
          },
          {
            path: "poster/type",
            component: resolve => require(["@/modules/poster/pages/type.vue"], resolve)
          },
          {
            path: "poster/subject",
            component: resolve => require(["@/modules/poster/pages/subject.vue"], resolve)
          },
          {
            path: "poster/statistics",
            name:'statistics',
            component: resolve => require(["@/modules/poster/pages/statistics.vue"], resolve)
          },
          {
            path: "poster/guestset",
            name:'guestset',
            component: resolve => require(["@/modules/poster/pages/guestSet.vue"], resolve)
          },
          {
            path: "poster/banner",
            name:'banner',
            component: resolve => require(["@/modules/poster/pages/banner.vue"], resolve)
          }
        ]
      }
    ]
  }
];
